"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCampaigns = exports.hasBrands = exports.hasAdSets = exports.hasAds = exports.geotype = exports.geolocations = exports.geo = exports.excludedQuestions = exports.excludedLocations = exports.excludedKeywords = exports.excludedGeolocations = exports.excludedAudiences = exports.deviceAndBrowser = exports.deliveryStatus = exports.delivering = exports.dailyBudget = exports.cta = exports.creativeType = exports.creativeDescription = exports.copyDescription = exports.conversionEvent = exports.conversionObjective = exports.campaign = exports.businessName = exports.brandLogo = exports.brandAccount = exports.bodyText = exports.bidAmount = exports.audience = exports.assetFile = exports.answers = exports.advertiser = exports.adSet = exports.adDelivery = exports.ExecutableAction = exports.Topic = exports.QuoraAccount = exports.Question = exports.Location = exports.Delivering = exports.Campaign = exports.BrandAccount = exports.BaseShape = exports.Audience = exports.Answer = exports.AdSet = exports.Ad = exports._self = exports.ns = exports.loadData = void 0;
exports.dailyLead = exports.dailySales = exports.payout = exports.clicksSinceLastSale = exports.dailySpend = exports.totalSales = exports.dailyImpressions = exports.accountCurrency = exports.ctr = exports.cpc = exports.dailyClicks = exports.targetingTheme = exports.subHeadlineDescription = exports.headlineDescription = exports.quoraName = exports.targetsAllGenders = exports.viewsUpperBound = exports.viewsLowerBound = exports.vertical = exports.utmTemplate = exports.trackers = exports.targetsUnknown = exports.mediaId = exports.accountId = exports.targetsMales = exports.targetsFemales = exports.targetingType = exports.targetingDescription = exports.subVertical = exports.statusGuidance = exports.status = exports.retargetingWindow = exports.quoraAccount = exports.promotedAnswer = exports.platform = exports.placement = exports.offer = exports.network = exports.lifetimeBudget = exports.launchDate = exports.keywords = exports.isTemplate = exports.isQuickLaunched = exports.isAutoTargeting = exports.includedLocations = exports.headline = exports.hasTopics = exports.hasQuestions = exports.hasFullLandingPageUrl = exports.hasLandingPage = void 0;
exports.titanAds = exports.spendSinceLastSale = exports.question = exports.answer = exports.lastExecuted = exports.LevelInfo = exports.dateModified = exports.lastModified = exports.automation = exports.lastReductionDate = exports.dailyRevenue = exports.totalRevenue = exports.optimized = exports.totalSearch = exports.totalLead = exports.totalSpend = exports.totalImpressions = exports.totalClicks = exports.fromTemplate = exports.targetShape = exports.parameters = exports.method = exports.QuoraAPI = exports.video = exports.image = exports.hasBeenUnpaused = exports.voluumReport = exports.cakeReport = exports.campaignName = exports.conversions = exports.uniqueClicks = exports.uniqueVisitors = exports.visits = exports.adName = exports.Voluum = exports.revenue = exports.cakeStartDate = exports.subIdSecondary = exports.subIdPrimary = exports.startDate = exports.trackingId = exports.timestamp = exports.creativeName = exports.offerName = exports.eventName = exports.Cake = exports.dailySearch = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//import all the exports of this file as one variable called _this (we need this at the end)
const _this = __importStar(require("./titan-ads"));
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
const loadData = () => {
    return Promise.resolve().then(() => __importStar(require('../data/titan-ads.json'))).then((data) => JSONLD_1.JSONLD.parse(data));
};
exports.loadData = loadData;
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
exports.ns = (0, NameSpace_1.createNameSpace)('http://dashboard.titan.com/');
/**
 * The NamedNode of the ontology itself
 */
exports._self = (0, exports.ns)('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
// Classes
exports.Ad = (0, exports.ns)('Ad'); // Will belong to one adset
exports.AdSet = (0, exports.ns)('AdSet'); // Will have many ads (but will belong to one account)
exports.Answer = (0, exports.ns)('Answer'); // Will have many ads (but will belong to one account)
exports.Audience = (0, exports.ns)('Audience'); // Will have many ads (but will belong to one account)
exports.BaseShape = (0, exports.ns)('BaseShape'); // The base shape for all the shapes in this ontology
exports.BrandAccount = (0, exports.ns)('BrandAccount'); // Will have many campaigns
exports.Campaign = (0, exports.ns)('Campaign'); // Will have many adsets (but will belong to one account)
exports.Delivering = (0, exports.ns)('Delivering');
exports.Location = (0, exports.ns)('Location');
exports.Question = (0, exports.ns)('Question');
exports.QuoraAccount = (0, exports.ns)('QuoraAccount');
exports.Topic = (0, exports.ns)('Topic');
exports.ExecutableAction = (0, exports.ns)('ExecutableAction');
// Properties
exports.adDelivery = (0, exports.ns)('adDelivery');
exports.adSet = (0, exports.ns)('adSet');
exports.advertiser = (0, exports.ns)('advertiser');
exports.answers = (0, exports.ns)('answers');
exports.assetFile = (0, exports.ns)('assetFile');
exports.audience = (0, exports.ns)('audience');
exports.bidAmount = (0, exports.ns)('bidAmount');
exports.bodyText = (0, exports.ns)('bodyText');
exports.brandAccount = (0, exports.ns)('brandAccount');
exports.brandLogo = (0, exports.ns)('brandLogo');
exports.businessName = (0, exports.ns)('businessName');
exports.campaign = (0, exports.ns)('campaign');
exports.conversionObjective = (0, exports.ns)('conversionObjective');
exports.conversionEvent = (0, exports.ns)('conversionEvent');
exports.copyDescription = (0, exports.ns)('copyDescription');
exports.creativeDescription = (0, exports.ns)('creativeDescription');
exports.creativeType = (0, exports.ns)('creativeType');
exports.cta = (0, exports.ns)('cta');
exports.dailyBudget = (0, exports.ns)('dailyBudget');
exports.delivering = (0, exports.ns)('delivering');
exports.deliveryStatus = (0, exports.ns)('deliveryStatus');
exports.deviceAndBrowser = (0, exports.ns)('deviceAndBrowser');
exports.excludedAudiences = (0, exports.ns)('excludedAudiences');
exports.excludedGeolocations = (0, exports.ns)('excludedGeolocations');
exports.excludedKeywords = (0, exports.ns)('excludedKeywords');
exports.excludedLocations = (0, exports.ns)('excludedLocations');
exports.excludedQuestions = (0, exports.ns)('excludedQuestions');
exports.geo = (0, exports.ns)('geo');
exports.geolocations = (0, exports.ns)('geolocations');
exports.geotype = (0, exports.ns)('geotype');
exports.hasAds = (0, exports.ns)('hasAds');
exports.hasAdSets = (0, exports.ns)('hasAdSets');
exports.hasBrands = (0, exports.ns)('hasBrands');
exports.hasCampaigns = (0, exports.ns)('hasCampaigns');
exports.hasLandingPage = (0, exports.ns)('hasLandingPage');
exports.hasFullLandingPageUrl = (0, exports.ns)('hasFullLandingPageUrl');
exports.hasQuestions = (0, exports.ns)('hasQuestions');
exports.hasTopics = (0, exports.ns)('hasTopics');
exports.headline = (0, exports.ns)('headline');
exports.includedLocations = (0, exports.ns)('includedLocations');
exports.isAutoTargeting = (0, exports.ns)('isAutoTargeting');
exports.isQuickLaunched = (0, exports.ns)('isQuickLaunched');
exports.isTemplate = (0, exports.ns)('isTemplate');
exports.keywords = (0, exports.ns)('keywords');
exports.launchDate = (0, exports.ns)('launchDate');
exports.lifetimeBudget = (0, exports.ns)('lifetimeBudget');
exports.network = (0, exports.ns)('network');
exports.offer = (0, exports.ns)('offer');
exports.placement = (0, exports.ns)('placement');
exports.platform = (0, exports.ns)('platform');
exports.promotedAnswer = (0, exports.ns)('promotedAnswer');
exports.quoraAccount = (0, exports.ns)('quoraAccount');
exports.retargetingWindow = (0, exports.ns)('retargetingWindow');
exports.status = (0, exports.ns)('status');
exports.statusGuidance = (0, exports.ns)('statusGuidance');
exports.subVertical = (0, exports.ns)('subVertical');
exports.targetingDescription = (0, exports.ns)('targetingDescription');
exports.targetingType = (0, exports.ns)('targetingType');
exports.targetsFemales = (0, exports.ns)('targetsFemales');
exports.targetsMales = (0, exports.ns)('targetsMales');
exports.accountId = (0, exports.ns)('accountId');
exports.mediaId = (0, exports.ns)('mediaId');
exports.targetsUnknown = (0, exports.ns)('targetsUnknown');
exports.trackers = (0, exports.ns)('trackers');
exports.utmTemplate = (0, exports.ns)('utmTemplate');
exports.vertical = (0, exports.ns)('vertical');
exports.viewsLowerBound = (0, exports.ns)('viewsLowerBound');
exports.viewsUpperBound = (0, exports.ns)('viewsUpperBound');
exports.targetsAllGenders = (0, exports.ns)('targetsAllGenders');
exports.quoraName = (0, exports.ns)('quoraName');
exports.headlineDescription = (0, exports.ns)('headlineDescription');
exports.subHeadlineDescription = (0, exports.ns)('subHeadlineDescription');
exports.targetingTheme = (0, exports.ns)('targetingTheme');
exports.dailyClicks = (0, exports.ns)('dailyClicks');
exports.cpc = (0, exports.ns)('cpc');
exports.ctr = (0, exports.ns)('ctr');
exports.accountCurrency = (0, exports.ns)('accountCurrency');
exports.dailyImpressions = (0, exports.ns)('dailyImpressions');
exports.totalSales = (0, exports.ns)('totalSales');
exports.dailySpend = (0, exports.ns)('dailySpend');
exports.clicksSinceLastSale = (0, exports.ns)('clicksSinceLastSale');
exports.payout = (0, exports.ns)('payout');
exports.dailySales = (0, exports.ns)('dailySales');
exports.dailyLead = (0, exports.ns)('dailyLead');
exports.dailySearch = (0, exports.ns)('dailySearch');
exports.Cake = (0, exports.ns)('Cake');
exports.eventName = (0, exports.ns)('eventName');
exports.offerName = (0, exports.ns)('offerName');
exports.creativeName = (0, exports.ns)('creativeName');
exports.timestamp = (0, exports.ns)('timestamp');
exports.trackingId = (0, exports.ns)('trackingId');
exports.startDate = (0, exports.ns)('startDate');
exports.subIdPrimary = (0, exports.ns)('subIdPrimary');
exports.subIdSecondary = (0, exports.ns)('subIdSecondary');
exports.cakeStartDate = (0, exports.ns)('cakeStartDate');
exports.revenue = (0, exports.ns)('revenue');
exports.Voluum = (0, exports.ns)('Voluum');
exports.adName = (0, exports.ns)('adName');
exports.visits = (0, exports.ns)('visits');
exports.uniqueVisitors = (0, exports.ns)('uniqueVisitors');
exports.uniqueClicks = (0, exports.ns)('uniqueClicks');
exports.conversions = (0, exports.ns)('conversions');
exports.campaignName = (0, exports.ns)('campaignName');
exports.cakeReport = (0, exports.ns)('cakeReport');
exports.voluumReport = (0, exports.ns)('voluumReport');
exports.hasBeenUnpaused = (0, exports.ns)('hasBeenUnpaused');
exports.image = (0, exports.ns)('image');
exports.video = (0, exports.ns)('video');
exports.QuoraAPI = (0, exports.ns)('QuoraAPI');
exports.method = (0, exports.ns)('method');
exports.parameters = (0, exports.ns)('parameters');
exports.targetShape = (0, exports.ns)('targetShape');
exports.fromTemplate = (0, exports.ns)('fromTemplate');
exports.totalClicks = (0, exports.ns)('totalClicks');
exports.totalImpressions = (0, exports.ns)('totalImpressions');
exports.totalSpend = (0, exports.ns)('totalSpend');
exports.totalLead = (0, exports.ns)('totalLead');
exports.totalSearch = (0, exports.ns)('totalSearch');
exports.optimized = (0, exports.ns)('optimized');
exports.totalRevenue = (0, exports.ns)('totalRevenue');
exports.dailyRevenue = (0, exports.ns)('dailyRevenue');
exports.lastReductionDate = (0, exports.ns)('lastReductionDate');
exports.automation = (0, exports.ns)('automation');
exports.lastModified = (0, exports.ns)('lastModified');
exports.dateModified = (0, exports.ns)('dateModified');
exports.LevelInfo = (0, exports.ns)('LevelInfo');
exports.lastExecuted = (0, exports.ns)('lastExecuted');
exports.answer = (0, exports.ns)('answer');
exports.question = (0, exports.ns)('question');
exports.spendSinceLastSale = (0, exports.ns)('spendSinceLastSale');
//An extra grouping object so all the entities can be accessed from the prefix/name
exports.titanAds = {
    // Classes
    Ad: exports.Ad,
    AdSet: exports.AdSet,
    Cake: exports.Cake,
    LevelInfo: exports.LevelInfo,
    cakeReport: exports.cakeReport,
    voluumReport: exports.voluumReport,
    Voluum: exports.Voluum,
    QuoraAPI: exports.QuoraAPI,
    Answer: exports.Answer,
    headlineDescription: exports.headlineDescription,
    subHeadlineDescription: exports.subHeadlineDescription,
    Audience: exports.Audience,
    BaseShape: exports.BaseShape,
    accountId: exports.accountId,
    mediaId: exports.mediaId,
    BrandAccount: exports.BrandAccount,
    Campaign: exports.Campaign,
    Delivering: exports.Delivering,
    Location: exports.Location,
    Question: exports.Question,
    QuoraAccount: exports.QuoraAccount,
    Topic: exports.Topic,
    ExecutableAction: exports.ExecutableAction,
    dailySearch: exports.dailySearch,
    dailyLead: exports.dailyLead,
    // Properties
    quoraName: exports.quoraName,
    targetingTheme: exports.targetingTheme,
    adDelivery: exports.adDelivery,
    adSet: exports.adSet,
    advertiser: exports.advertiser,
    dailySpend: exports.dailySpend,
    answers: exports.answers,
    assetFile: exports.assetFile,
    audience: exports.audience,
    bidAmount: exports.bidAmount,
    bodyText: exports.bodyText,
    brandAccount: exports.brandAccount,
    brandLogo: exports.brandLogo,
    businessName: exports.businessName,
    image: exports.image,
    video: exports.video,
    campaign: exports.campaign,
    conversionObjective: exports.conversionObjective,
    conversionEvent: exports.conversionEvent,
    hasBeenUnpaused: exports.hasBeenUnpaused,
    copyDescription: exports.copyDescription,
    creativeDescription: exports.creativeDescription,
    creativeType: exports.creativeType,
    cta: exports.cta,
    dailyBudget: exports.dailyBudget,
    delivering: exports.delivering,
    deliveryStatus: exports.deliveryStatus,
    deviceAndBrowser: exports.deviceAndBrowser,
    excludedAudiences: exports.excludedAudiences,
    excludedGeolocations: exports.excludedGeolocations,
    excludedKeywords: exports.excludedKeywords,
    excludedLocations: exports.excludedLocations,
    excludedQuestions: exports.excludedQuestions,
    fromTemplate: exports.fromTemplate,
    geo: exports.geo,
    geolocations: exports.geolocations,
    geotype: exports.geotype,
    hasAds: exports.hasAds,
    hasAdSets: exports.hasAdSets,
    hasBrands: exports.hasBrands,
    hasCampaigns: exports.hasCampaigns,
    hasLandingPage: exports.hasLandingPage,
    hasFullLandingPageUrl: exports.hasFullLandingPageUrl,
    hasQuestions: exports.hasQuestions,
    hasTopics: exports.hasTopics,
    headline: exports.headline,
    includedLocations: exports.includedLocations,
    isAutoTargeting: exports.isAutoTargeting,
    isQuickLaunched: exports.isQuickLaunched,
    isTemplate: exports.isTemplate,
    keywords: exports.keywords,
    launchDate: exports.launchDate,
    lifetimeBudget: exports.lifetimeBudget,
    network: exports.network,
    offer: exports.offer,
    lastReductionDate: exports.lastReductionDate,
    totalLead: exports.totalLead,
    totalSearch: exports.totalSearch,
    totalSales: exports.totalSales,
    placement: exports.placement,
    platform: exports.platform,
    promotedAnswer: exports.promotedAnswer,
    quoraAccount: exports.quoraAccount,
    retargetingWindow: exports.retargetingWindow,
    status: exports.status,
    statusGuidance: exports.statusGuidance,
    subVertical: exports.subVertical,
    targetingType: exports.targetingType,
    targetingDescription: exports.targetingDescription,
    targetsFemales: exports.targetsFemales,
    targetsAllGenders: exports.targetsAllGenders,
    targetsMales: exports.targetsMales,
    targetsUnknown: exports.targetsUnknown,
    trackers: exports.trackers,
    utmTemplate: exports.utmTemplate,
    vertical: exports.vertical,
    viewsLowerBound: exports.viewsLowerBound,
    viewsUpperBound: exports.viewsUpperBound,
    dailyClicks: exports.dailyClicks,
    cpc: exports.cpc,
    ctr: exports.ctr,
    accountCurrency: exports.accountCurrency,
    dailyImpressions: exports.dailyImpressions,
    clicksSinceLastSale: exports.clicksSinceLastSale,
    payout: exports.payout,
    dailySales: exports.dailySales,
    eventName: exports.eventName,
    offerName: exports.offerName,
    creativeName: exports.creativeName,
    timestamp: exports.timestamp,
    trackingId: exports.trackingId,
    startDate: exports.startDate,
    subIdPrimary: exports.subIdPrimary,
    subIdSecondary: exports.subIdSecondary,
    cakeStartDate: exports.cakeStartDate,
    revenue: exports.revenue,
    adName: exports.adName,
    visits: exports.visits,
    uniqueVisitors: exports.uniqueVisitors,
    uniqueClicks: exports.uniqueClicks,
    conversions: exports.conversions,
    campaignName: exports.campaignName,
    totalClicks: exports.totalClicks,
    totalImpressions: exports.totalImpressions,
    totalSpend: exports.totalSpend,
    method: exports.method,
    parameters: exports.parameters,
    targetShape: exports.targetShape,
    optimized: exports.optimized,
    totalRevenue: exports.totalRevenue,
    dailyRevenue: exports.dailyRevenue,
    automation: exports.automation,
    lastModified: exports.lastModified,
    dateModified: exports.dateModified,
    lastExecuted: exports.lastExecuted,
    answer: exports.answer,
    question: exports.question,
    spendSinceLastSale: exports.spendSinceLastSale
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
(0, package_1.linkedOntology)(_this, exports.ns, 'titan-ads', exports.loadData, '../data/titan-ads.json');
//# sourceMappingURL=titan-ads.js.map